import { createFileRoute } from '@tanstack/react-router';
import { FileStoragePage } from '@/features/file-storage';

export const Route = createFileRoute('/_authenticated/file-storage')({
  component: FileStoragePage,
}); 